import { forwardRef } from "react";

import AppIconButton, { AppIconButtonProps } from "../../../Button/AppIconButton";

interface Props extends AppIconButtonProps {}

export const EntityInlineActionIconButton = forwardRef<HTMLButtonElement, Props>(
  function EntityInlineActionIconButtonInternal({ children, onClick, ...otherProps }: Props, ref) {
    return (
      <AppIconButton
        ref={ref}
        sx={{ p: 0.25 }}
        size='small'
        onClick={(e) => {
          // prevent navigation when inside a link
          e.preventDefault();
          e.stopPropagation();

          onClick?.(e);
        }}
        {...otherProps}
      >
        {children}
      </AppIconButton>
    );
  },
);
